import { useState, useEffect } from 'react';
import { getStoreHours, StoreHoursData } from '../services/storeHoursApiService.ts';

export const useStoreHours = (storeId: string | null) => {
  const [storeHours, setStoreHours] = useState<StoreHoursData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!storeId) {
      setStoreHours(null);
      return;
    }

    const fetchStoreHours = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const hours = await getStoreHours(storeId);
        setStoreHours(hours);
      } catch (err: any) {
        console.error('Error fetching store hours:', err);
        setError(err.message || 'Failed to load store hours');
        setStoreHours(null);
      } finally {
        setLoading(false);
      }
    };

    fetchStoreHours();
  }, [storeId]);

  return { storeHours, loading, error };
};